import React, { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import './Modal.css';
import './ModalGestionUsuario.css';

const CAPACIDADES = [
  { id: 'overview',   label: '📊 RESUMEN' },
  { id: 'usuarios',   label: '👥 USUARIOS' },
  { id: 'voluntarios', label: '🦺 BRIGADA' },
  { id: 'campanias',  label: '🎯 CAMPAÑAS' },
  { id: 'puntos',     label: '⭐ PUNTOS' },
  { id: 'eventos',    label: '📅 ACTIVIDADES' },
  { id: 'reportes',   label: '🚨 REPORTES' },
  { id: 'animales',   label: '🐾 ANIMALES' },
  { id: 'avisos',     label: '📣 AVISOS' },
  { id: 'donaciones', label: '💰 DONACIONES' },
  { id: 'logs',       label: '📜 HISTORIAL' },
  { id: 'config',     label: '⚙️ AJUSTES' },
];

export default function ModalGestionUsuario({ user, onClose, onUpdated }) {
  const [rol, setRol] = useState(user.rol || 'publico');
  const [permisos, setPermisos] = useState(user.permisos || []);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const togglePermiso = (id) => {
    setPermisos(prev =>
      prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
    );
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put(`/usuarios/${user._id}/manage`, {
        rol,
        permisos,
        password: password || undefined
      });
      toast.success('Capacidades actualizadas correctamente');
      onUpdated();
      onClose();
    } catch (e) {
      toast.error('Error al actualizar usuario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay zg" onClick={onClose}>
      <div className="modal-content guser fade-up" onClick={e => e.stopPropagation()}>

        <div className="guser-hd">
          <div className="guser-hd-t">
            <span className="guser-hd-ico">⚙️</span>
            <h2>Gestionar Administrador</h2>
          </div>
          <button className="modal-close-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>

        <div className="guser-who">
          <strong>{user.nombre} {user.apellido}</strong>
          <span>{user.email}</span>
        </div>

        <div className="guser-block">
          <label className="guser-lbl">Rol de Usuario</label>
          <select
            className="f-inp guser-sel"
            value={rol}
            onChange={(e) => setRol(e.target.value)}
          >
            <option value="admin">Administrador Principal</option>
            <option value="maestro">Maestro / Coordinador</option>
            <option value="finanzas">Finanzas</option>
            <option value="moderador">Moderador</option>
            <option value="estudiante">Estudiante / Voluntario</option>
            <option value="publico">Público General</option>
          </select>
          <p className="guser-hint">ℹ️ Los roles administrativos están restringidos para evitar descensos accidentales.</p>
        </div>

        <div className="guser-block">
          <div className="guser-lbl-row">
            <label className="guser-lbl">Capacidades / Funciones Permitidas</label>
            <span className="guser-count">{permisos.length}/{CAPACIDADES.length}</span>
          </div>
          <div className="guser-caps">
            {CAPACIDADES.map(cap => (
              <label
                key={cap.id}
                className={`guser-cap ${permisos.includes(cap.id) ? 'on' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={permisos.includes(cap.id)}
                  onChange={() => togglePermiso(cap.id)}
                />
                <span>{cap.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="guser-block">
          <label className="guser-lbl">Asignar nueva clave</label>
          <input
            className="f-inp"
            type="password"
            placeholder="Nueva contraseña..."
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>

        <div className="guser-ft">
          <button className="btn btn-outline-v" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button
            className="btn btn-v"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? 'Guardando...' : 'Guardar Capacidades'}
          </button>
        </div>

      </div>
    </div>
  );
}
